import { router } from '@inertiajs/react'

export function useServiceActions(orgSlug: string, orderId: number) {
  const completeService = (itemId: number, serviceId: number) => {
    router.post(
      `/organizations/${orgSlug}/orders/${orderId}/articles/${itemId}/services/${serviceId}/toggle_completion`,
      {},
      { preserveScroll: true }
    )
  }

  const verifyService = (itemId: number, serviceId: number) => {
    router.post(
      `/organizations/${orgSlug}/orders/${orderId}/articles/${itemId}/services/${serviceId}/toggle_verification`,
      {},
      { preserveScroll: true }
    )
  }

  return { completeService, verifyService }
}
